import { render } from "./NewsDetailView.vue?vue&type=template&id=0ebfbbba&scoped=true"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"

import "./NewsDetailView.vue?vue&type=style&index=0&id=0ebfbbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebfbbba"]])

export default __exports__